import { Stack } from '@mui/material'
import Link from '../Link'
import { SUPPORT_EMAIL } from '../../constants/constants'
import { useNavigate } from 'react-router'

export const BackToLogin = () => {
  const navigate = useNavigate()

  return (
    <Stack>
      <Link to="/login" onClick={() => navigate('/login')}>
        Back to Login
      </Link>
      <Link to={`mailto:${SUPPORT_EMAIL}`}>{'Contact ' + SUPPORT_EMAIL}</Link>
    </Stack>
  )
}
